@if (!loading && vista; as v) {
  <section class="detalle">
    <!-- Resumen: estado y lo más consultado. La identidad (nombre, domicilio,
         cliente, alta) está en el encabezado de la página. -->
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Estado" ocultarVacio>
          <app-dt-estado
            [tono]="v.conexion.tono"
            [etiqueta]="v.conexion.etiqueta"
          />
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Última comunicación"
          [valor]="v.hace ? 'hace ' + (v.hace | lowercase) : null"
        >
          @if (v.hace) {
            <span class="dt-muted fecha">{{ v.ultimaComunicacion }}</span>
          }
        </app-dt-dato>
        <app-dt-dato etiqueta="Armado" [valor]="v.armado" />
        <app-dt-dato etiqueta="Activación" ocultarVacio>
          <app-dt-estado
            [tono]="v.activacion.tono"
            [etiqueta]="v.activacion.etiqueta"
          />
          @if (v.activacion.detalle) {
            <span class="dt-muted fecha">{{ v.activacion.detalle }}</span>
          }
        </app-dt-dato>
      </app-dt-datos>
    </app-dt-card>

    <!-- Grilla de tarjetas en orden fijo. El mapa es una tarjeta más: arriba
         a la derecha, del alto de las dos primeras. -->
    <div class="grilla">
      <app-dt-card titulo="Equipo" icono="doorbell" class="tarjeta">
        <app-dt-datos>
          <app-dt-dato etiqueta="Marca y modelo" [valor]="v.marcaModelo" />
          <app-dt-dato
            etiqueta="Número de abonado"
            [valor]="v.numeroAbonado"
            mono
            copiable
          />
          @if (v.nroDeSistema) {
            <app-dt-dato
              etiqueta="N° de sistema"
              [valor]="v.nroDeSistema"
              mono
              copiable
            />
          }
          @if (v.fechaAlta) {
            <app-dt-dato etiqueta="Fecha de alta" [valor]="v.fechaAlta" />
          }
          <app-dt-dato etiqueta="Fecha de creación" [valor]="v.fechaCreacion" />
        </app-dt-datos>
      </app-dt-card>

      @if (mapCardConfig) {
        <div class="tarjeta-mapa">
          <div class="mapa" #tarjetaMapa>
            <app-map-card
              [height]="
                pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '320px'
              "
              [config]="mapCardConfig"
            ></app-map-card>
          </div>
        </div>
      }

      <!-- Comunicación: la última comunicación ya está en el resumen -->
      <app-dt-card titulo="Comunicación" icono="cell_tower" class="tarjeta">
        <app-dt-datos>
          <app-dt-dato
            etiqueta="Frecuencia de reporte"
            [valor]="v.frecuencia"
          />
          <app-dt-dato
            etiqueta="ID único del comunicador"
            [valor]="v.idUnicoComunicador"
            mono
            copiable
          />
          @if (v.reenvios; as r) {
            <app-dt-dato
              etiqueta="Reglas de reenvío"
              [valor]="
                r.activas
                  ? r.activas + (r.activas === 1 ? ' activa' : ' activas')
                  : 'No hay activas'
              "
            >
              <button
                irxBotonIcono
                tamano="mini"
                [disabled]="!r.total"
                (click)="verReenvios()"
                [tooltip]="
                  r.total ? 'Ver reglas de reenvío' : 'Sin reglas de reenvío'
                "
              >
                <mat-icon>visibility</mat-icon>
              </button>
            </app-dt-dato>
          }
        </app-dt-datos>

        <span class="dt-label titulo-lista">Comunicadores</span>
        @if (v.comunicadores.length) {
          <div class="lista">
            @for (c of v.comunicadores; track $index) {
              <div class="fila">
                <div class="fila-texto">
                  <strong>{{ c.nombre }}</strong>
                  <span class="dt-muted">
                    @if (c.hace) {
                      hace {{ c.hace | lowercase }} · {{ c.fecha }}
                    } @else {
                      Sin comunicación
                    }
                  </span>
                </div>
                <app-dt-estado
                  [tono]="c.conexion.tono"
                  [etiqueta]="c.conexion.etiqueta"
                />
              </div>
            }
          </div>
        } @else {
          <span class="dt-muted">Sin comunicadores cargados</span>
        }
      </app-dt-card>

      <app-dt-card titulo="SIMs" icono="sim_card" class="tarjeta">
        <app-dt-sims [sims]="v.sims" />
      </app-dt-card>

      <app-dt-card titulo="Cámaras" icono="videocam" class="tarjeta">
        @if (v.camaras.length) {
          <div class="lista">
            @for (c of v.camaras; track c.id) {
              <div class="fila">
                <div class="fila-texto">
                  <strong>{{ c.nombre }}</strong>
                  @if (c.detalle) {
                    <span class="dt-muted">{{ c.detalle }}</span>
                  }
                  @if (c.host) {
                    <span class="dt-muted dt-mono">{{ c.host }}</span>
                  }
                </div>
                @if (c.ruta) {
                  <a class="irx-enlace dt-link" [routerLink]="c.ruta">
                    Ver cámara
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <span class="dt-muted">No hay cámaras asociadas</span>
        }
      </app-dt-card>

      <app-dt-card titulo="Zonas" icono="sensors" class="tarjeta ancha">
        @if (v.zonas.length) {
          <div class="zonas">
            <!-- Alto fijo por zona (hasta dos sensores a la vista) y, con
                 paginación, siempre 8 lugares: así todas las páginas miden
                 lo mismo. -->
            @for (z of zonasDePagina(v.zonas); track $index) {
              <div
                class="zona"
                [matTooltip]="
                  z.sensores.length > 2 ? z.sensores.join(' / ') : ''
                "
              >
                <strong class="linea">{{ z.nombre }}</strong>
                @if (z.descripcion) {
                  <span class="dt-muted linea">{{ z.descripcion }}</span>
                }
                @for (
                  s of z.sensores.slice(0, z.sensores.length > 2 ? 1 : 2);
                  track $index
                ) {
                  <span class="sensor">
                    <mat-icon>sensors</mat-icon>
                    <span class="linea">{{ s }}</span>
                  </span>
                }
                @if (z.sensores.length > 2) {
                  <span class="dt-muted linea">
                    +{{ z.sensores.length - 1 }} sensores más
                  </span>
                }
              </div>
            }
            @for (h of huecosZonas(v.zonas); track $index) {
              <div class="zona hueco"></div>
            }
          </div>
          @if (v.zonas.length > ZONAS_POR_PAGINA) {
            <div class="paginador">
              <span class="dt-muted">{{ rangoZonas(v.zonas) }}</span>
              <button
                irxBotonIcono
                tamano="compacto"
                [disabled]="paginaZonas() === 0"
                (click)="moverZonas(-1, v.zonas)"
                tooltip="Zonas anteriores"
              >
                <mat-icon>chevron_left</mat-icon>
              </button>
              <button
                irxBotonIcono
                tamano="compacto"
                [disabled]="paginaZonas() >= ultimaPaginaZonas(v.zonas)"
                (click)="moverZonas(1, v.zonas)"
                tooltip="Zonas siguientes"
              >
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }
        } @else {
          <span class="dt-muted">No hay zonas configuradas</span>
        }
      </app-dt-card>

      <app-dt-card
        titulo="Imágenes"
        icono="photo_library"
        class="tarjeta ancha"
      >
        @if (v.imagenes.length) {
          <app-carrusel [imagenes]="v.imagenes"></app-carrusel>
        } @else {
          <span class="dt-muted">No hay imágenes cargadas</span>
        }
      </app-dt-card>
    </div>
  </section>
} @else if (!loading) {
  <!-- La página ya muestra "No se encontró la alarma"; esto cubre que la
       consulta de Info falle sola. -->
  <app-empty-state
    icon="notifications_off"
    message="No se pudo cargar la información de la alarma"
  ></app-empty-state>
} @else {
  <app-detalle-esqueleto soloCuerpo></app-detalle-esqueleto>
}
